import { Component, OnInit, ViewChild } from '@angular/core';
import { RebateRequestComponent } from 'src/app/front-user/services/long-haul/rebate-request/rebate-request.component';
import { Router } from '@angular/router';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { User } from 'src/app/front-user/shared/models/user.model';
import { RebateRequestRequestorDecisionComponent } from 'src/app/front-user/services/long-haul/rebate-request-requestor-decision/rebate-request-requestor-decision.component';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';

@Component({
  selector: 'app-rebate-request-request-details',
  templateUrl: './rebate-request-request-details.component.html'
})
export class RebateRequestRequestDetailsComponent implements OnInit {
  //#region Properties & Variables
  //Request Properties
  private rebateRequestId: string = "";
  private rebateRequestCreationDate;
  @ViewChild('rebateRequest',{static: false}) rebateRequest: RebateRequestComponent;
  @ViewChild('rebateRequestRequestorDecision',{static: false}) rebateRequestRequestorDecision: RebateRequestRequestorDecisionComponent;
  //User Properties
  public currentUser: User = new User();
  //#endregion

  constructor(private router: Router, private globalServices: GlobalServices, private authenticationService: AuthenticationService) {
    //this.currentUser = this.globalServices.user;
    this.currentUser = this.authenticationService.currentUserValue;
  }

  ngOnInit() {
    const el = document.getElementsByClassName('sectionTitle');
    el[0].scrollIntoView({behavior:'smooth'});
  }
  onRebateRequestLoadedFlag(flag: boolean) {
    if(flag){

      this.rebateRequestId = this.rebateRequest.rebateRequestLoaded.Id;
      this.rebateRequestCreationDate = this.rebateRequest.rebateRequestLoaded.CreationDate;
      this.rebateRequest.showOptionDev = false;
      this.rebateRequest.editModeAdmin = true;
    }
  }
  onRebateRequestRequestorDecisionLoadedFlag(flag: boolean) {
    if(flag){}
  }
  navigateToAccurateDataForm(): void {
    this.router.navigate(['RebateRequest/AccurateDataForm'], { state: { data: { requestId: this.rebateRequestId } } });
  }
  navigateToConfirmShipPassing(): void {
    this.router.navigate(['RebateRequest/ConfirmShipPassing'], { state: { data: { requestId: this.rebateRequestId } } });
  }
  navigateToReleaseRebate(): void {
    this.router.navigate(['RebateRequest/ReleaseRebate'], { state: { data: { requestId: this.rebateRequestId } } });
  }
  navigateToMarkRequestAsRefunded(): void {
    this.router.navigate(['RebateRequest/Refunded'], { state: { data: { requestId: this.rebateRequestId } } });
  }
  navigateToCloneRequest(): void {
    this.router.navigate(['RebateRequest/CloneRequest'], { state: { data: { requestId: this.rebateRequestId , ParentCreationDate : this.rebateRequestCreationDate} } });
  }
}
